<!-- Container -->
<div class="kt-container-fixed lg:flex lg:flex-wrap lg:justify-between lg:items-center gap-2 px-0 lg:px-7.5">
	<!-- Mega Menu -->
	<div class="kt-menu items-stretch flex-col lg:flex-row gap-5 lg:gap-7.5 grow lg:grow-0" data-kt-menu="true"
		id="mega_menu">
		<div class="kt-menu-item active">
			<a class="kt-menu-link lg:py-3.5 border-b border-b-transparent kt-menu-item-active:border-b-mono text-foreground kt-menu-item-hover:text-mono kt-menu-item-active:text-mono kt-menu-item-here:border-b-mono kt-menu-item-here:text-mono"
				href="/metronic/tailwind/demo9/">
				<span class="kt-menu-title font-medium text-foreground text-sm">
					Boards
				</span>
			</a>
		</div>
		<div class="kt-menu-item kt-menu-item-dropdown" data-kt-menu-item-placement="bottom-start"
			data-kt-menu-item-placement-rtl="bottom-end" data-kt-menu-item-toggle="accordion|lg:dropdown"
			data-kt-menu-item-trigger="click|lg:hover">
			<div
				class="kt-menu-link lg:py-3.5 border-b border-b-transparent kt-menu-item-active:border-b-mono text-foreground kt-menu-item-hover:text-mono kt-menu-item-active:text-mono kt-menu-item-here:border-b-mono kt-menu-item-here:text-mono">
				<span class="kt-menu-title font-medium text-foreground text-sm">
					Profiles
				</span>
				<span class="kt-menu-arrow flex lg:hidden">
					<span class="flex kt-menu-item-show:hidden">
						<i class="ki-filled ki-plus text-xs text-secondary-foreground">
						</i>
					</span>
					<span class="hidden kt-menu-item-show:inline-flex">
						<i class="ki-filled ki-minus text-xs text-secondary-foreground">
						</i>
					</span>
				</span>
			</div>
			<div class="kt-menu-dropdown w-full gap-0 lg:max-w-[900px]">
				<div class="pt-4 pb-2 lg:p-7.5">
					<div class="grid lg:grid-cols-2 gap-5 lg:gap-10">
						<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
							<h3 class="text-sm text-foreground font-semibold leading-none ps-2.5 mb-2 lg:mb-5">
								Profiles
							</h3>
							<div class="grid lg:grid-cols-2 lg:gap-5">
								<div class="flex flex-col gap-0.5">
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/public-profile/profiles/default"
											tabindex="0">
											<span class="kt-menu-icon">
												<i class="ki-filled ki-badge">
												</i>
											</span>
											<span class="kt-menu-title grow-0">
												Default
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/public-profile/profiles/creator"
											tabindex="0">
											<span class="kt-menu-icon">
												<i class="ki-filled ki-coffee">
												</i>
											</span>
											<span class="kt-menu-title grow-0">
												Creator
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/public-profile/profiles/company"
											tabindex="0">
											<span class="kt-menu-icon">
												<i class="ki-filled ki-abstract-41">
												</i>
											</span>
											<span class="kt-menu-title grow-0">
												Company
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/public-profile/profiles/nft" tabindex="0">
											<span class="kt-menu-icon">
												<i class="ki-filled ki-bitcoin">
												</i>
											</span>
											<span class="kt-menu-title grow-0">
												NFT
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/public-profile/profiles/blogger"
											tabindex="0">
											<span class="kt-menu-icon">
												<i class="ki-filled ki-message-text">
												</i>
											</span>
											<span class="kt-menu-title grow-0">
												Blogger
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/public-profile/profiles/crm" tabindex="0">
											<span class="kt-menu-icon">
												<i class="ki-filled ki-devices">
												</i>
											</span>
											<span class="kt-menu-title grow-0">
												CRM
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/public-profile/profiles/gamer" tabindex="0">
											<span class="kt-menu-icon">
												<i class="ki-filled ki-ghost">
												</i>
											</span>
											<span class="kt-menu-title grow-0">
												Gamer
											</span>
										</a>
									</div>
								</div>
								<div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/public-profile/profiles/feeds" tabindex="0">
											<span class="kt-menu-icon">
												<i class="ki-filled ki-book">
												</i>
											</span>
											<span class="kt-menu-title grow-0">
												Feeds
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/public-profile/profiles/plain" tabindex="0">
											<span class="kt-menu-icon">
												<i class="ki-filled ki-files">
												</i>
											</span>
											<span class="kt-menu-title grow-0">
												Plain
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/public-profile/profiles/modal" tabindex="0">
											<span class="kt-menu-icon">
												<i class="ki-filled ki-mouse-square">
												</i>
											</span>
											<span class="kt-menu-title grow-0">
												Modal
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link" href="#" tabindex="0">
											<span class="kt-menu-icon">
												<i class="ki-filled ki-financial-schedule">
												</i>
											</span>
											<span class="kt-menu-title grow-0">
												Freelancer
											</span>
											<span class="kt-menu-badge">
												<span class="kt-badge kt-badge-sm">
													Soon
												</span>
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link" href="#" tabindex="0">
											<span class="kt-menu-icon">
												<i class="ki-filled ki-technology-4">
												</i>
											</span>
											<span class="kt-menu-title grow-0">
												Developer
											</span>
											<span class="kt-menu-badge">
												<span class="kt-badge kt-badge-sm">
													Soon
												</span>
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link" href="#" tabindex="0">
											<span class="kt-menu-icon">
												<i class="ki-filled ki-users">
												</i>
											</span>
											<span class="kt-menu-title grow-0">
												Team
											</span>
											<span class="kt-menu-badge">
												<span class="kt-badge kt-badge-sm">
													Soon
												</span>
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link" href="#" tabindex="0">
											<span class="kt-menu-icon">
												<i class="ki-filled ki-calendar-tick">
												</i>
											</span>
											<span class="kt-menu-title grow-0">
												Events
											</span>
											<span class="kt-menu-badge">
												<span class="kt-badge kt-badge-sm">
													Soon
												</span>
											</span>
										</a>
									</div>
								</div>
							</div>
						</div>
						<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
							<h3 class="text-sm text-foreground font-semibold leading-none ps-2.5 mb-2 lg:mb-5">
								Other Pages
							</h3>
							<div class="grid lg:grid-cols-2 lg:gap-5">
								<div class="flex flex-col gap-0.5">
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/public-profile/projects/3-columns"
											tabindex="0">
											<span class="kt-menu-icon">
												<i class="ki-filled ki-element-6">
												</i>
											</span>
											<span class="kt-menu-title grow-0">
												Projects - 3 Columns
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/public-profile/projects/2-columns"
											tabindex="0">
											<span class="kt-menu-icon">
												<i class="ki-filled ki-element-4">
												</i>
											</span>
											<span class="kt-menu-title grow-0">
												Projects - 2 Columns
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link" href="/metronic/tailwind/demo9/public-profile/works"
											tabindex="0">
											<span class="kt-menu-icon">
												<i class="ki-filled ki-office-bag">
												</i>
											</span>
											<span class="kt-menu-title grow-0">
												Works
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link" href="/metronic/tailwind/demo9/public-profile/teams"
											tabindex="0">
											<span class="kt-menu-icon">
												<i class="ki-filled ki-people">
												</i>
											</span>
											<span class="kt-menu-title grow-0">
												Teams
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link" href="/metronic/tailwind/demo9/public-profile/network"
											tabindex="0">
											<span class="kt-menu-icon">
												<i class="ki-filled ki-icon">
												</i>
											</span>
											<span class="kt-menu-title grow-0">
												Network
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link" href="/metronic/tailwind/demo9/public-profile/activity"
											tabindex="0">
											<span class="kt-menu-icon">
												<i class="ki-filled ki-chart-line-up-2">
												</i>
											</span>
											<span class="kt-menu-title grow-0">
												Activity
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/public-profile/campaigns/card" tabindex="0">
											<span class="kt-menu-icon">
												<i class="ki-filled ki-element-11">
												</i>
											</span>
											<span class="kt-menu-title grow-0">
												Campaigns - Card
											</span>
										</a>
									</div>
								</div>
								<div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/public-profile/campaigns/list" tabindex="0">
											<span class="kt-menu-icon">
												<i class="ki-filled ki-kanban">
												</i>
											</span>
											<span class="kt-menu-title grow-0">
												Campaigns - List
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link" href="/metronic/tailwind/demo9/public-profile/empty"
											tabindex="0">
											<span class="kt-menu-icon">
												<i class="ki-filled ki-file-sheet">
												</i>
											</span>
											<span class="kt-menu-title grow-0">
												Empty Page
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link" href="#" tabindex="0">
											<span class="kt-menu-icon">
												<i class="ki-filled ki-document">
												</i>
											</span>
											<span class="kt-menu-title grow-0">
												Documents
											</span>
											<span class="kt-menu-badge">
												<span class="kt-badge kt-badge-sm">
													Soon
												</span>
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link" href="#" tabindex="0">
											<span class="kt-menu-icon">
												<i class="ki-filled ki-award">
												</i>
											</span>
											<span class="kt-menu-title grow-0">
												Badges
											</span>
											<span class="kt-menu-badge">
												<span class="kt-badge kt-badge-sm">
													Soon
												</span>
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link" href="#" tabindex="0">
											<span class="kt-menu-icon">
												<i class="ki-filled ki-gift">
												</i>
											</span>
											<span class="kt-menu-title grow-0">
												Awards
											</span>
											<span class="kt-menu-badge">
												<span class="kt-badge kt-badge-sm">
													Soon
												</span>
											</span>
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					class="flex flex-wrap items-center lg:justify-between rounded-xl lg:rounded-t-none border border-border lg:border-0 lg:border-t lg:border-t-border px-4 py-4 lg:px-7.5 lg:py-5 gap-2.5 bg-muted/50">
					<div class="flex flex-col gap-1.5">
						<div class="text-base font-semibold text-mono leading-none">
							Read to Get Started ?
						</div>
						<div class="text-sm fomt-medium text-secondary-foreground">
							Take your docs to the next level of Metronic
						</div>
					</div>
					<a class="kt-btn kt-btn-mono" href="#">
						Read Documentation
					</a>
				</div>
			</div>
		</div>
		<div class="kt-menu-item kt-menu-item-dropdown" data-kt-menu-item-offset="-158px, 0"
			data-kt-menu-item-offset-rtl="158px, 0" data-kt-menu-item-overflow="true"
			data-kt-menu-item-placement="bottom-start" data-kt-menu-item-placement-rtl="bottom-end"
			data-kt-menu-item-toggle="accordion|lg:dropdown" data-kt-menu-item-trigger="click|lg:hover">
			<div
				class="kt-menu-link lg:py-3.5 border-b border-b-transparent kt-menu-item-active:border-b-mono text-foreground kt-menu-item-hover:text-mono kt-menu-item-active:text-mono kt-menu-item-here:border-b-mono kt-menu-item-here:text-mono">
				<span class="kt-menu-title font-medium text-foreground text-sm">
					Account
				</span>
				<span class="kt-menu-arrow flex lg:hidden">
					<span class="flex kt-menu-item-show:hidden">
						<i class="ki-filled ki-plus text-xs text-secondary-foreground">
						</i>
					</span>
					<span class="hidden kt-menu-item-show:inline-flex">
						<i class="ki-filled ki-minus text-xs text-secondary-foreground">
						</i>
					</span>
				</span>
			</div>
			<div class="kt-menu-dropdown flex-col lg:flex-row gap-0 w-full lg:max-w-[1240px]">
				<div
					class="lg:w-[250px] mt-2 lg:mt-0 lg:border-e lg:border-e-border rounded-xl lg:rounded-l-xl lg:rounded-r-none shrink-0 px-3 py-4 lg:p-7.5 bg-muted/25">
					<h3 class="text-sm text-foreground font-semibold leading-none ps-2.5 mb-2 lg:mb-5">
						General Pages
					</h3>
					<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
						<div class="kt-menu-item">
							<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
								href="/metronic/tailwind/demo9/account/integrations">
								<span class="kt-menu-icon">
									<i class="ki-filled ki-technology-2">
									</i>
								</span>
								<span class="kt-menu-title grow-0">
									Integrations
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
								href="/metronic/tailwind/demo9/account/notifications">
								<span class="kt-menu-icon">
									<i class="ki-filled ki-notification-1">
									</i>
								</span>
								<span class="kt-menu-title grow-0">
									Notifications
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
								href="/metronic/tailwind/demo9/account/api-keys">
								<span class="kt-menu-icon">
									<i class="ki-filled ki-key">
									</i>
								</span>
								<span class="kt-menu-title grow-0">
									API Keys
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
								href="/metronic/tailwind/demo9/account/appearance">
								<span class="kt-menu-icon">
									<i class="ki-filled ki-eye">
									</i>
								</span>
								<span class="kt-menu-title grow-0">
									Appearance
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
								href="/metronic/tailwind/demo9/account/invite-a-friend">
								<span class="kt-menu-icon">
									<i class="ki-filled ki-user-tick">
									</i>
								</span>
								<span class="kt-menu-title grow-0">
									Invite a Friend
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
								href="/metronic/tailwind/demo9/account/activity">
								<span class="kt-menu-icon">
									<i class="ki-filled ki-support">
									</i>
								</span>
								<span class="kt-menu-title grow-0">
									Activity
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
								href="">
								<span class="kt-menu-icon">
									<i class="ki-filled ki-verify">
									</i>
								</span>
								<span class="kt-menu-title grow-0">
									Brand
								</span>
								<span class="kt-menu-badge">
									<span class="kt-badge kt-badge-sm">
										Soon
									</span>
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
								href="">
								<span class="kt-menu-icon">
									<i class="ki-filled ki-euro">
									</i>
								</span>
								<span class="kt-menu-title grow-0">
									Get Paid
								</span>
								<span class="kt-menu-badge">
									<span class="kt-badge kt-badge-sm">
										Soon
									</span>
								</span>
							</a>
						</div>
					</div>
				</div>
				<div class="pt-4 pb-2 lg:p-7.5 lg:pb-5 grow">
					<div class="grid lg:grid-cols-5 gap-5">
						<div class="flex flex-col">
							<h3 class="text-sm text-foreground font-semibold leading-none ps-2.5 mb-2 lg:mb-5">
								Account Home
							</h3>
							<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="/metronic/tailwind/demo9/account/home/get-started"
										tabindex="0">
										<span class="kt-menu-title grow-0">
											Get Started
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="/metronic/tailwind/demo9/account/home/user-profile"
										tabindex="0">
										<span class="kt-menu-title grow-0">
											User Profile
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="/metronic/tailwind/demo9/account/home/company-profile"
										tabindex="0">
										<span class="kt-menu-title grow-0">
											Company Profile
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link"
										href="/metronic/tailwind/demo9/account/home/settings-sidebar" tabindex="0">
										<span class="kt-menu-title grow-0">
											With Sidebar
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link"
										href="/metronic/tailwind/demo9/account/home/settings-enterprise" tabindex="0">
										<span class="kt-menu-title grow-0">
											Enterprise
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="/metronic/tailwind/demo9/account/home/settings-plain"
										tabindex="0">
										<span class="kt-menu-title grow-0">
											Plain
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="/metronic/tailwind/demo9/account/home/settings-modal"
										tabindex="0">
										<span class="kt-menu-title grow-0">
											Modal
										</span>
									</a>
								</div>
							</div>
						</div>
						<div class="flex flex-col">
							<h3 class="text-sm text-foreground font-semibold leading-none ps-2.5 mb-2 lg:mb-5">
								Billing
							</h3>
							<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="/metronic/tailwind/demo9/account/billing/basic"
										tabindex="0">
										<span class="kt-menu-title grow-0">
											Basic Billing
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="/metronic/tailwind/demo9/account/billing/enterprise"
										tabindex="0">
										<span class="kt-menu-title grow-0">
											Enterprise
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="/metronic/tailwind/demo9/account/billing/plans"
										tabindex="0">
										<span class="kt-menu-title grow-0">
											Plans
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="/metronic/tailwind/demo9/account/billing/history"
										tabindex="0">
										<span class="kt-menu-title grow-0">
											Billing History
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="" tabindex="0">
										<span class="kt-menu-title grow-0">
											Tax Info
										</span>
										<span class="kt-menu-badge">
											<span class="kt-badge kt-badge-sm">
												Soon
											</span>
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="" tabindex="0">
										<span class="kt-menu-title grow-0">
											Invoices
										</span>
										<span class="kt-menu-badge">
											<span class="kt-badge kt-badge-sm">
												Soon
											</span>
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="" tabindex="0">
										<span class="kt-menu-title grow-0">
											Gateaways
										</span>
										<span class="kt-menu-badge">
											<span class="kt-badge kt-badge-sm">
												Soon
											</span>
										</span>
									</a>
								</div>
							</div>
						</div>
						<div class="flex flex-col">
							<h3 class="text-sm text-foreground font-semibold leading-none ps-2.5 mb-2 lg:mb-5">
								Security
							</h3>
							<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="/metronic/tailwind/demo9/account/security/get-started"
										tabindex="0">
										<span class="kt-menu-title grow-0">
											Get Started
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="/metronic/tailwind/demo9/account/security/overview"
										tabindex="0">
										<span class="kt-menu-title grow-0">
											Security Overview
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link"
										href="/metronic/tailwind/demo9/account/security/allowed-ip-addresses"
										tabindex="0">
										<span class="kt-menu-title grow-0">
											IP Addresses
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link"
										href="/metronic/tailwind/demo9/account/security/privacy-settings" tabindex="0">
										<span class="kt-menu-title grow-0">
											Privacy Settings
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link"
										href="/metronic/tailwind/demo9/account/security/device-management" tabindex="0">
										<span class="kt-menu-title grow-0">
											Device Management
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link"
										href="/metronic/tailwind/demo9/account/security/backup-and-recovery"
										tabindex="0">
										<span class="kt-menu-title grow-0">
											Backup &amp; Recovery
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link"
										href="/metronic/tailwind/demo9/account/security/current-sessions" tabindex="0">
										<span class="kt-menu-title grow-0">
											Current Sessions
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link"
										href="/metronic/tailwind/demo9/account/security/security-log" tabindex="0">
										<span class="kt-menu-title grow-0">
											Security Log
										</span>
									</a>
								</div>
							</div>
						</div>
						<div class="flex flex-col">
							<h3 class="text-sm text-foreground font-semibold leading-none ps-2.5 mb-2 lg:mb-5">
								Members &amp; Roles
							</h3>
							<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="/metronic/tailwind/demo9/account/members/team-starter"
										tabindex="0">
										<span class="kt-menu-title grow-0">
											Teams Starter
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="/metronic/tailwind/demo9/account/members/teams"
										tabindex="0">
										<span class="kt-menu-title grow-0">
											Teams
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="/metronic/tailwind/demo9/account/members/team-info"
										tabindex="0">
										<span class="kt-menu-title grow-0">
											Team Info
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link"
										href="/metronic/tailwind/demo9/account/members/members-starter" tabindex="0">
										<span class="kt-menu-title grow-0">
											Members Starter
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="/metronic/tailwind/demo9/account/members/team-members"
										tabindex="0">
										<span class="kt-menu-title grow-0">
											Team Members
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link"
										href="/metronic/tailwind/demo9/account/members/import-members" tabindex="0">
										<span class="kt-menu-title grow-0">
											Import Members
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="/metronic/tailwind/demo9/account/members/roles"
										tabindex="0">
										<span class="kt-menu-title grow-0">
											Roles
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link"
										href="/metronic/tailwind/demo9/account/members/permissions-toggle" tabindex="0">
										<span class="kt-menu-title grow-0">
											Persmissions - Toggler
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link"
										href="/metronic/tailwind/demo9/account/members/permissions-check" tabindex="0">
										<span class="kt-menu-title grow-0">
											Persmissions - Check
										</span>
									</a>
								</div>
							</div>
						</div>
						<div class="flex flex-col">
							<h3 class="text-sm text-foreground font-semibold leading-none ps-2.5 mb-2 lg:mb-5">
								Other Pages
							</h3>
							<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="/metronic/tailwind/demo9/account/integrations"
										tabindex="0">
										<span class="kt-menu-title grow-0">
											Integrations
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="/metronic/tailwind/demo9/account/notifications"
										tabindex="0">
										<span class="kt-menu-title grow-0">
											Notifications
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="/metronic/tailwind/demo9/account/api-keys"
										tabindex="0">
										<span class="kt-menu-title grow-0">
											API Keys
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="/metronic/tailwind/demo9/account/appearance"
										tabindex="0">
										<span class="kt-menu-title grow-0">
											Appearance
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="/metronic/tailwind/demo9/account/invite-a-friend"
										tabindex="0">
										<span class="kt-menu-title grow-0">
											Invite a Friend
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="/metronic/tailwind/demo9/account/activity"
										tabindex="0">
										<span class="kt-menu-title grow-0">
											Activity
										</span>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="kt-menu-item kt-menu-item-dropdown" data-kt-menu-item-offset="-50px, 0"
			data-kt-menu-item-offset-rtl="50px, 0" data-kt-menu-item-overflow="true"
			data-kt-menu-item-placement="bottom-start" data-kt-menu-item-placement-rtl="bottom-end"
			data-kt-menu-item-toggle="accordion|lg:dropdown" data-kt-menu-item-trigger="click|lg:hover">
			<div
				class="kt-menu-link lg:py-3.5 border-b border-b-transparent kt-menu-item-active:border-b-mono text-foreground kt-menu-item-hover:text-mono kt-menu-item-active:text-mono kt-menu-item-here:border-b-mono kt-menu-item-here:text-mono">
				<span class="kt-menu-title font-medium text-foreground text-sm">
					Network
				</span>
				<span class="kt-menu-arrow flex lg:hidden">
					<span class="flex kt-menu-item-show:hidden">
						<i class="ki-filled ki-plus text-xs text-secondary-foreground">
						</i>
					</span>
					<span class="hidden kt-menu-item-show:inline-flex">
						<i class="ki-filled ki-minus text-xs text-secondary-foreground">
						</i>
					</span>
				</span>
			</div>
			<div class="kt-menu-dropdown flex-col gap-0 w-full lg:max-w-[670px]">
				<div class="flex flex-col lg:flex-row">
					<div
						class="flex flex-col gap-5 lg:w-[250px] mt-2 lg:mt-0 lg:border-r lg:border-r-border rounded-xl lg:rounded-none lg:rounded-tl-xl shrink-0 px-3 py-4 lg:p-7.5 bg-muted/25">
						<h3 class="text-sm text-foreground font-semibold leading-none ps-2.5 h-3.5">
							General Pages
						</h3>
						<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
							<div class="kt-menu-item">
								<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
									href="#">
									<span class="kt-menu-icon">
										<i class="ki-filled ki-flag">
										</i>
									</span>
									<span class="kt-menu-title grow-0">
										Get Started
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
									href="#">
									<span class="kt-menu-icon">
										<i class="ki-filled ki-users">
										</i>
									</span>
									<span class="kt-menu-title grow-0">
										Colleagues
									</span>
									<span class="kt-menu-badge">
										<span class="kt-badge kt-badge-sm">
											Soon
										</span>
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
									href="#">
									<span class="kt-menu-icon">
										<i class="ki-filled ki-heart">
										</i>
									</span>
									<span class="kt-menu-title grow-0">
										Donators
									</span>
									<span class="kt-menu-badge">
										<span class="kt-badge kt-badge-sm">
											Soon
										</span>
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
									href="#">
									<span class="kt-menu-icon">
										<i class="ki-filled ki-abstract-21">
										</i>
									</span>
									<span class="kt-menu-title grow-0">
										Leads
									</span>
									<span class="kt-menu-badge">
										<span class="kt-badge kt-badge-sm">
											Soon
										</span>
									</span>
								</a>
							</div>
						</div>
					</div>
					<div class="pt-4 pb-2 lg:p-7.5 lg:pb-5 grow">
						<div class="grid lg:grid-cols-2 gap-5">
							<div class="flex flex-col gap-5">
								<h3
									class="flex items-center gap-1.5 text-sm text-foreground font-semibold leading-none ps-2.5 h-3.5">
									User Cards
								</h3>
								<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/network/user-cards/mini-cards" tabindex="0">
											<span class="kt-menu-title grow-0">
												Mini Cards
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/network/user-cards/team-crew" tabindex="0">
											<span class="kt-menu-title grow-0">
												Team Crew
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link" href="/metronic/tailwind/demo9/network/user-cards/nft"
											tabindex="0">
											<span class="kt-menu-title grow-0">
												Authors
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/network/user-cards/social" tabindex="0">
											<span class="kt-menu-title grow-0">
												NFT Users
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link" href="#" tabindex="0">
											<span class="kt-menu-title grow-0">
												Social Users
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link" href="#" tabindex="0">
											<span class="kt-menu-title grow-0">
												Gamers
											</span>
											<span class="kt-menu-badge">
												<span class="kt-badge kt-badge-sm">
													Soon
												</span>
											</span>
										</a>
									</div>
								</div>
							</div>
							<div class="flex flex-col gap-5">
								<h3
									class="flex items-center gap-1.5 text-sm text-foreground font-semibold leading-none ps-2.5 h-3.5">
									User Base
									<span class="left-auto kt-badge kt-badge-sm kt-badge-primary kt-badge-outline">
										Datatables
									</span>
								</h3>
								<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/network/user-table/team-crew" tabindex="0">
											<span class="kt-menu-title grow-0">
												Team Crew
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/network/user-table/app-roster" tabindex="0">
											<span class="kt-menu-title grow-0">
												App Roster
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/network/user-table/market-authors"
											tabindex="0">
											<span class="kt-menu-title grow-0">
												Market Authors
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/network/user-table/saas-users" tabindex="0">
											<span class="kt-menu-title grow-0">
												SaaS Users
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/network/user-table/store-clients"
											tabindex="0">
											<span class="kt-menu-title grow-0">
												Store Clients
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/network/user-table/visitors" tabindex="0">
											<span class="kt-menu-title grow-0">
												Visitors
											</span>
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					class="flex flex-wrap items-center lg:justify-between rounded-xl lg:rounded-t-none border border-border lg:border-0 lg:border-t lg:border-t-border px-4 py-4 lg:px-7.5 lg:py-5 gap-2.5 bg-muted/50">
					<div class="flex flex-col gap-1.5">
						<div class="text-base font-semibold text-mono leading-none">
							Read to Get Started ?
						</div>
						<div class="text-sm fomt-medium text-secondary-foreground">
							Take your docs to the next level of Metronic
						</div>
					</div>
					<a class="kt-btn kt-btn-mono" href="#">
						Read Documentation
					</a>
				</div>
			</div>
		</div>
		<div class="kt-menu-item" data-kt-menu-item-offset="-50px, 0" data-kt-menu-item-offset-rtl="50px, 0"
			data-kt-menu-item-overflow="true" data-kt-menu-item-placement="bottom-start"
			data-kt-menu-item-placement-rtl="bottom-end" data-kt-menu-item-toggle="accordion|lg:dropdown"
			data-kt-menu-item-trigger="click|lg:hover">
			<div
				class="kt-menu-link lg:py-3.5 border-b border-b-transparent kt-menu-item-active:border-b-mono text-foreground kt-menu-item-hover:text-mono kt-menu-item-active:text-mono kt-menu-item-here:border-b-mono kt-menu-item-here:text-mono">
				<span class="kt-menu-title font-medium text-foreground text-sm">
					Store
				</span>
				<span class="kt-menu-arrow flex lg:hidden">
					<span class="flex kt-menu-item-show:hidden">
						<i class="ki-filled ki-plus text-xs text-secondary-foreground">
						</i>
					</span>
					<span class="hidden kt-menu-item-show:inline-flex">
						<i class="ki-filled ki-minus text-xs text-secondary-foreground">
						</i>
					</span>
				</span>
			</div>

			<div class="kt-menu-dropdown w-full gap-0 lg:max-w-[600px]" style="">
				<div class="pt-4 pb-2 lg:p-7.5">
					<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
						<h3 class="text-sm text-foreground font-semibold leading-none ps-2.5 mb-2 lg:mb-5">
							Store - Client
						</h3>
						<div class="grid lg:grid-cols-2 lg:gap-5">
							<div class="flex flex-col gap-0.5">
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="/metronic/tailwind/demo9/store-client/home"
										tabindex="0">
										<span class="kt-menu-icon">
											<i class="ki-filled ki-home">
											</i>
										</span>
										<span class="kt-menu-title grow-0">
											Home
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link"
										href="/metronic/tailwind/demo9/store-client/search-results-grid" tabindex="0">
										<span class="kt-menu-icon">
											<i class="ki-filled ki-grid">
											</i>
										</span>
										<span class="kt-menu-title grow-0">
											Search Results - Grid
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link"
										href="/metronic/tailwind/demo9/store-client/search-results-list" tabindex="0">
										<span class="kt-menu-icon">
											<i class="ki-filled ki-tablet-text-up">
											</i>
										</span>
										<span class="kt-menu-title grow-0">
											Search Results - List
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="/metronic/tailwind/demo9/store-client/product-details"
										tabindex="0">
										<span class="kt-menu-icon">
											<i class="ki-filled ki-picture">
											</i>
										</span>
										<span class="kt-menu-title grow-0">
											Product Details
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="/metronic/tailwind/demo9/store-client/shopping-cart"
										tabindex="0">
										<span class="kt-menu-icon">
											<i class="ki-filled ki-handcart">
											</i>
										</span>
										<span class="kt-menu-title grow-0">
											Shopping Cart
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="/metronic/tailwind/demo9/store-client/wishlist"
										tabindex="0">
										<span class="kt-menu-icon">
											<i class="ki-filled ki-heart">
											</i>
										</span>
										<span class="kt-menu-title grow-0">
											Wishlist
										</span>
									</a>
								</div>
							</div>
							<div>
								<div class="kt-menu-item">
									<a class="kt-menu-link"
										href="/metronic/tailwind/demo9/store-client/checkout/order-summary"
										tabindex="0">
										<span class="kt-menu-icon">
											<i class="ki-filled ki-subtitle">
											</i>
										</span>
										<span class="kt-menu-title grow-0">
											Checkout - Order Summary
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link"
										href="/metronic/tailwind/demo9/store-client/checkout/shipping-info"
										tabindex="0">
										<span class="kt-menu-icon">
											<i class="ki-filled ki-delivery">
											</i>
										</span>
										<span class="kt-menu-title grow-0">
											Checkout - Shipping Info
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link"
										href="/metronic/tailwind/demo9/store-client/checkout/payment-method"
										tabindex="0">
										<span class="kt-menu-icon">
											<i class="ki-filled ki-wallet">
											</i>
										</span>
										<span class="kt-menu-title grow-0">
											Checkout - Payment Method
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link"
										href="/metronic/tailwind/demo9/store-client/checkout/order-placed" tabindex="0">
										<span class="kt-menu-icon">
											<i class="ki-filled ki-check-circle">
											</i>
										</span>
										<span class="kt-menu-title grow-0">
											Checkout - Order Placed
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="/metronic/tailwind/demo9/store-client/my-orders"
										tabindex="0">
										<span class="kt-menu-icon">
											<i class="ki-filled ki-archive">
											</i>
										</span>
										<span class="kt-menu-title grow-0">
											My Orders
										</span>
									</a>
								</div>
								<div class="kt-menu-item">
									<a class="kt-menu-link" href="/metronic/tailwind/demo9/store-client/order-receipt"
										tabindex="0">
										<span class="kt-menu-icon">
											<i class="ki-filled ki-document">
											</i>
										</span>
										<span class="kt-menu-title grow-0">
											Order Receipt
										</span>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					class="flex flex-wrap items-center lg:justify-between rounded-xl lg:rounded-t-none border border-border lg:border-0 lg:border-t lg:border-t-border px-4 py-4 lg:px-7.5 lg:py-5 gap-2.5 bg-muted/50">
					<div class="flex flex-col gap-1.5">
						<div class="text-base font-semibold text-mono leading-none">
							Read to Get Started ?
						</div>
						<div class="text-sm fomt-medium text-secondary-foreground">
							Take your docs to the next level of Metronic
						</div>
					</div>
					<a class="kt-btn kt-btn-mono" href="#">
						Read Documentation
					</a>
				</div>
			</div>
		</div>
		<div class="kt-menu-item" data-kt-menu-item-offset="-100px, 0" data-kt-menu-item-offset-rtl="100px, 0"
			data-kt-menu-item-overflow="true" data-kt-menu-item-placement="bottom-start"
			data-kt-menu-item-placement-rtl="bottom-end" data-kt-menu-item-toggle="accordion|lg:dropdown"
			data-kt-menu-item-trigger="click|lg:hover">
			<div
				class="kt-menu-link lg:py-3.5 border-b border-b-transparent kt-menu-item-active:border-b-mono text-foreground kt-menu-item-hover:text-mono kt-menu-item-active:text-mono kt-menu-item-here:border-b-mono kt-menu-item-here:text-mono">
				<span class="kt-menu-title font-medium text-foreground text-sm">
					Auth
				</span>
				<span class="kt-menu-arrow flex lg:hidden">
					<span class="flex kt-menu-item-show:hidden">
						<i class="ki-filled ki-plus text-xs text-secondary-foreground">
						</i>
					</span>
					<span class="hidden kt-menu-item-show:inline-flex">
						<i class="ki-filled ki-minus text-xs text-secondary-foreground">
						</i>
					</span>
				</span>
			</div>

			<div class="kt-menu-dropdown flex-col gap-0 w-full lg:max-w-[700px]" style="">
				<div class="flex flex-col lg:flex-row">
					<div class="pt-4 pb-2 lg:p-7.5 lg:pb-5 grow">
						<div class="grid lg:grid-cols-2 gap-5">
							<div class="flex flex-col">
								<h3 class="text-sm text-foreground font-semibold leading-none ps-2.5 mb-2 lg:mb-5">
									Classic Layout
								</h3>
								<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/authentication/classic/sign-in" tabindex="0">
											<span class="kt-menu-title grow-0">
												Sign In
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/authentication/classic/sign-up" tabindex="0">
											<span class="kt-menu-title grow-0">
												Sign Up
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/authentication/classic/2fa" tabindex="0">
											<span class="kt-menu-title grow-0">
												2FA
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/authentication/classic/check-email"
											tabindex="0">
											<span class="kt-menu-title grow-0">
												Check Email
											</span>
										</a>
									</div>
									<div class="kt-menu-item pt-1">
										<span class="text-secondary-foreground font-medium text-sm p-2.5">
											Reset Password
										</span>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/authentication/classic/reset-password/enter-email"
											tabindex="0">
											<span class="kt-menu-title grow-0">
												Enter Email
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/authentication/classic/reset-password/check-email"
											tabindex="0">
											<span class="kt-menu-title grow-0">
												Check Email
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/authentication/classic/reset-password/change-password"
											tabindex="0">
											<span class="kt-menu-title grow-0">
												Change Password
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/authentication/classic/reset-password/password-changed"
											tabindex="0">
											<span class="kt-menu-title grow-0">
												Password is Changed
											</span>
										</a>
									</div>
								</div>
							</div>
							<div class="flex flex-col">
								<h3 class="text-sm text-foreground font-semibold leading-none ps-2.5 mb-2 lg:mb-5">
									Branded Layout
								</h3>
								<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/authentication/branded/sign-in" tabindex="0">
											<span class="kt-menu-title grow-0">
												Sign In
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/authentication/branded/sign-up" tabindex="0">
											<span class="kt-menu-title grow-0">
												Sign Up
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/authentication/branded/2fa" tabindex="0">
											<span class="kt-menu-title grow-0">
												2FA
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/authentication/branded/check-email"
											tabindex="0">
											<span class="kt-menu-title grow-0">
												Check Email
											</span>
										</a>
									</div>
									<div class="kt-menu-item pt-1">
										<span class="text-secondary-foreground font-medium text-sm p-2.5">
											Reset Password
										</span>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/authentication/branded/reset-password/enter-email"
											tabindex="0">
											<span class="kt-menu-title grow-0">
												Enter Email
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/authentication/branded/reset-password/check-email"
											tabindex="0">
											<span class="kt-menu-title grow-0">
												Check Email
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/authentication/branded/reset-password/change-password"
											tabindex="0">
											<span class="kt-menu-title grow-0">
												Change Password
											</span>
										</a>
									</div>
									<div class="kt-menu-item">
										<a class="kt-menu-link"
											href="/metronic/tailwind/demo9/authentication/branded/reset-password/password-changed"
											tabindex="0">
											<span class="kt-menu-title grow-0">
												Password is Changed
											</span>
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div
						class="lg:w-[260px] mb-4 lg:mb-0 lg:border-s lg:border-s-border rounded-xl lg:rounded-e-xl lg:rounded-l-none shrink-0 px-3 py-4 lg:p-7.5 bg-muted/25">
						<h3 class="text-sm text-foreground font-semibold leading-none ps-2.5 mb-5">
							Other Pages
						</h3>
						<div class="kt-menu kt-menu-default kt-menu-fit flex-col">
							<div class="kt-menu-item">
								<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
									href="/metronic/tailwind/demo9/authentication/welcome-message">
									<span class="kt-menu-icon">
										<i class="ki-filled ki-like-2">
										</i>
									</span>
									<span class="kt-menu-title grow-0">
										Welcome Message
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
									href="/metronic/tailwind/demo9/authentication/account-deactivated">
									<span class="kt-menu-icon">
										<i class="ki-filled ki-shield-cross">
										</i>
									</span>
									<span class="kt-menu-title grow-0">
										Account Deactivated
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
									href="/metronic/tailwind/demo9/authentication/error-404">
									<span class="kt-menu-icon">
										<i class="ki-filled ki-message-question">
										</i>
									</span>
									<span class="kt-menu-title grow-0">
										Error 404
									</span>
								</a>
							</div>
							<div class="kt-menu-item">
								<a class="kt-menu-link border border-transparent kt-menu-link-hover:!bg-background kt-menu-link-hover:border-border kt-menu-item-active:!bg-background kt-menu-item-active:border-border"
									href="/metronic/tailwind/demo9/authentication/error-500">
									<span class="kt-menu-icon">
										<i class="ki-filled ki-information">
										</i>
									</span>
									<span class="kt-menu-title grow-0">
										Error 500
									</span>
								</a>
							</div>
						</div>
					</div>
				</div>
				<div
					class="flex flex-wrap items-center lg:justify-between rounded-xl lg:rounded-t-none border border-border lg:border-0 lg:border-t lg:border-t-border px-4 py-4 lg:px-7.5 lg:py-5 gap-2.5 bg-muted/50">
					<div class="flex flex-col gap-1.5">
						<div class="text-base font-semibold text-mono leading-none">
							Read to Get Started ?
						</div>
						<div class="text-sm fomt-medium text-secondary-foreground">
							Take your docs to the next level of Metronic
						</div>
					</div>
					<a class="kt-btn kt-btn-mono" href="#">
						Read Documentation
					</a>
				</div>
			</div>
		</div>
		<div class="kt-menu-item" data-kt-menu-item-offset="0,0|lg:-20px, 0"
			data-kt-menu-item-offset-rtl="0,0|lg:20px, 0" data-kt-menu-item-overflow="true"
			data-kt-menu-item-placement="bottom-start" data-kt-menu-item-placement-rtl="bottom-end"
			data-kt-menu-item-toggle="dropdown" data-kt-menu-item-trigger="click|lg:hover">
			<div
				class="kt-menu-link lg:py-3.5 border-b border-b-transparent kt-menu-item-active:border-b-mono text-foreground kt-menu-item-hover:text-mono kt-menu-item-active:text-mono kt-menu-item-here:border-b-mono kt-menu-item-here:text-mono">
				<span class="kt-menu-title font-medium text-foreground text-sm">
					Help
				</span>
				<span class="kt-menu-arrow flex lg:hidden">
					<span class="flex kt-menu-item-show:hidden">
						<i class="ki-filled ki-plus text-xs text-secondary-foreground">
						</i>
					</span>
					<span class="hidden kt-menu-item-show:inline-flex">
						<i class="ki-filled ki-minus text-xs text-secondary-foreground">
						</i>
					</span>
				</span>
			</div>

			<div class="kt-menu-dropdown kt-menu-default py-2.5 w-full max-w-[220px]" style="">
				<div class="kt-menu-item">
					<a class="kt-menu-link"
						href="https://keenthemes.com/metronic/tailwind/docs/getting-started/installation" tabindex="0">
						<span class="kt-menu-icon">
							<i class="ki-filled ki-coffee">
							</i>
						</span>
						<span class="kt-menu-title grow-0">
							Getting Started
						</span>
					</a>
				</div>
				<div class="kt-menu-item kt-menu-item-dropdown" data-kt-menu-item-placement="right-start"
					data-kt-menu-item-placement-rtl="left-start" data-kt-menu-item-toggle="dropdown"
					data-kt-menu-item-trigger="click|lg:hover">
					<div class="kt-menu-link">
						<span class="kt-menu-icon">
							<i class="ki-filled ki-information">
							</i>
						</span>
						<span class="kt-menu-title">
							Support Forum
						</span>
						<span class="kt-menu-arrow">
							<i class="ki-filled ki-right text-xs rtl:transform rtl:rotate-180">
							</i>
						</span>
					</div>
					<div class="kt-menu-dropdown kt-menu-default w-full max-w-[175px] lg:max-w-[220px]">
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="https://devs.keenthemes.com" tabindex="0">
								<span class="kt-menu-icon">
									<i class="ki-filled ki-questionnaire-tablet">
									</i>
								</span>
								<span class="kt-menu-title grow-0">
									All Questions
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="https://devs.keenthemes.com/popular" tabindex="0">
								<span class="kt-menu-icon">
									<i class="ki-filled ki-star">
									</i>
								</span>
								<span class="kt-menu-title grow-0">
									Popular Questions
								</span>
							</a>
						</div>
						<div class="kt-menu-item">
							<a class="kt-menu-link" href="https://devs.keenthemes.com/question/create" tabindex="0">
								<span class="kt-menu-icon">
									<i class="ki-filled ki-message-question">
									</i>
								</span>
								<span class="kt-menu-title grow-0">
									Ask Question
								</span>
							</a>
						</div>
					</div>
				</div>
				<div class="kt-menu-item">
					<a class="kt-menu-link" href="https://keenthemes.com/metronic/tailwind/docs/getting-started/license"
						tabindex="0">
						<span class="kt-menu-icon">
							<i class="ki-filled ki-subtitle">
							</i>
						</span>
						<span class="kt-menu-title">
							Licenses &amp; FAQ
						</span>
						<span class="kt-menu-badge" data-kt-tooltip="#menu_tooltip_3"
							data-kt-tooltip-initialized="true">
							<i class="ki-filled ki-information-2 text-muted-foreground text-base">
							</i>
						</span>
						<div class="kt-tooltip" id="menu_tooltip_3">
							Learn more about licenses
						</div>
					</a>
				</div>
				<div class="kt-menu-item">
					<a class="kt-menu-link" href="https://keenthemes.com/metronic/tailwind/docs" tabindex="0">
						<span class="kt-menu-icon">
							<i class="ki-filled ki-questionnaire-tablet">
							</i>
						</span>
						<span class="kt-menu-title grow-0">
							Documentation
						</span>
					</a>
				</div>
				<div class="kt-menu-separator">
				</div>
				<div class="kt-menu-item">
					<a class="kt-menu-link" href="https://keenthemes.com/contact" tabindex="0">
						<span class="kt-menu-icon">
							<i class="ki-filled ki-share">
							</i>
						</span>
						<span class="kt-menu-title grow-0">
							Contact Us
						</span>
					</a>
				</div>
			</div>
		</div>
	</div>
	<!-- End of Mega Menu -->
</div>
<!-- End of Container -->